export const environment = {
  production: false,
  env: 'Testing',
  ApiUrl: 'https://ccpzposapitest.clavisco.com/',
  ReportManager: 'https://rptmanagertest.clavisco.com/',
  SentryDsn: 'https://92c25ac39346feecf8a92fe19799126b@o4511328163725312.ingest.us.sentry.io/4511951119974400'
};
